import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../components/modal/modal.component';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
    constructor(private dialog: MatDialog) {}

    async confirm(options: {
        title: string;
        description: string;
        confirmText?: string;
        cancelText?: string;
    }): Promise<'confirm' | 'cancel'> {
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                title: options.title,
                variant: 'confirm',
                description: options.description,
                confirmText: options.confirmText ?? 'Confirm',
                cancelText: options.cancelText ?? 'Cancel',
            },
        });

        return await firstValueFrom(dialogRef.afterClosed());
    }

    async export<T = any>(options: {
        title: string;
        initialFileName: string;
        confirmText?: string;
        cancelText?: string;
    }): Promise<T | null> {
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                title: options.title,
                variant: 'export',
                fileName: options.initialFileName,
                confirmText: options.confirmText ?? 'Export',
                cancelText: options.cancelText ?? 'Cancel',
            },
        });

        return await firstValueFrom(dialogRef.afterClosed());
    }
}
